import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/tx.jpg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-94c09c30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside__top" }
const _hoisted_2 = { class: "top_left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "top_search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-search" }, null, -1))
const _hoisted_6 = { class: "search_input" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user_ava" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_9 = { class: "moreMenu" }
const _hoisted_10 = ["onClick"]

import { computed, defineComponent, onMounted, reactive, ref, watch,nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { menu, menuList } from "./../../hooks/nav"
import bus from "@/utils/bus";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'navTop',
  setup(__props) {

const route = useRoute();
const router = useRouter();
let {path:oldPaht} = route

const store = useStore();

let state = reactive({
    sidebarMenu: computed(()=>store.getters.GET_MENU),
    currentMenu: computed(()=>store.getters.GET_CURRENTMENU),
    isSidebarNavCollapse: computed(()=>store.getters.getIsSidebarNavCollapse),
    navList:[],
    navActive:0
});

let keyword = ref('');//搜索课程关键词
let userName = ref('');//用户名

onMounted(()=>{
    // 头部切换
    if(JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("navList"))))){
        state.navList = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("navList"))))
    }
    // 刷新后nav切换的index
    if(JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("navActive"))))){
        state.navActive = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("navActive"))))
    }
})

const navChange=(item:any,index:number)=>{
    state.navActive=index
    bus.emit('eventActive', item,index)
    if (item.AliasName ==='配套资料'){
        router.push({ name: 'databank', query: { Id: item.Id, AliasName: item.AliasName } })
    }else {
        router.push({ name: 'recordedBroadcast', query: { Id: item.Id, AliasName: item.AliasName } })
    }
}
// 获取首页跳转至详情页后的index
bus.on('navActive', (index: number) => {
    state.navActive = index
})

const backIndex=()=>{
    router.replace("/teaIndex");
}
// 获取当前用户信息
userName.value = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("userinfo")))).Name;

// 退出登录
let loginOut = () => {
    router.go(0);
    window.localStorage.clear();
    router.replace("/login");
};
let toMenu = (path: string,index: number,id=0) => {
    if(id===5){
        window.open(path)
    }else{
        menu.value.map((item: any) => item.isSelect = false)
        menu.value[index].isSelect = true
        // 存索引
        localStorage.setItem('navIndex', index.toString())
        router.replace(path);
        localStorage.removeItem('ParentId')
        localStorage.removeItem('CurrId')
    }
};
let selectMoreMenu = (index: number) => {
    moreMenuList.map(item => item.isSelect = false)
    moreMenuList[index].isSelect = true
    if (moreMenuList[index].name === "退出登录") {
        loginOut()
    } else {
        router.replace({path: moreMenuList[index].path,query:{menuTitle: moreMenuList[index].name}});
        isShowMoreMenu.value = false
        menu.value.map((item: any) => item.isSelect = false)
    }
};

// 页面刷新选中对应菜单
if(oldPaht){
    const menuIndex = menuList.findIndex(e=>e.path===oldPaht)
    ~menuIndex && toMenu(oldPaht,menuIndex)
}

let isShowMoreMenu = ref(false);
// 点击头像后的更多菜单列表
const moreMenuList = reactive([{
    id:1,
    name:'个人中心',
    path:"/myCollect",
    isSelect:false
}, {
    id:5,
    name:'退出登录',
    path:"",
    isSelect:false
}]);
watch(() => route.query.menuTitle,(newVal,oldVal)=>{
    moreMenuList.map(item => {
        item.isSelect = false
        if (item.name === newVal) {
            item.isSelect = true
        }
    })
},{immediate:true})
// 是否展示更多
const showMore = () => {
    isShowMoreMenu.value = !isShowMoreMenu.value
};
// 搜索跳转
const toIndex = () => {
    menu.value.map((item:any) => item.isSelect = false)
    menu.value[0].isSelect = true
    if (keyword.value == undefined || keyword.value == null || keyword.value == ''){
        ElMessage.error('关键词不能为空！')
    }else{
        bus.emit('eventName', keyword.value)
        router.push({ path: 'searchList', query: { keyword: keyword.value } })
    }
};
// 清空按钮
const clearClick=()=>{
    keyword.value=''
    bus.emit('eventName', keyword.value)
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['top_page',{bg:_unref(store).state.isbg}])
  }, [
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "projectTitle",
          onClick: backIndex
        }, [
          _hoisted_3,
          _createTextVNode(" 奉节云校 ")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_input, {
              modelValue: _unref(keyword),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(keyword) ? (keyword).value = $event : keyword = $event)),
              modelModifiers: { trim: true },
              placeholder: "搜索关键词",
              onKeyup: _withKeys(toIndex, ["enter"]),
              clearable: "",
              onClear: clearClick
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['nav_box',{nav_display:!_unref(store).state.isbg}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).navList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["nav_item", _unref(state).navActive === index?'nav_item_active':'']),
            key: index,
            onClick: ($event: any) => (navChange(item,index))
          }, _toDisplayString(item.AliasName), 11, _hoisted_7))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        class: "top_user",
        onClick: showMore
      }, [
        _createElementVNode("span", null, _toDisplayString(_unref(userName)), 1),
        _hoisted_8
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moreMenuList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (_unref(selectMoreMenu)(index)),
            class: _normalizeClass(["moreMenu-item", item.isSelect?'active':'']),
            key: index
          }, _toDisplayString(item.name), 11, _hoisted_10))
        }), 128))
      ], 512), [
        [_vShow, _unref(isShowMoreMenu)]
      ])
    ])
  ], 2))
}
}

})